import { render, staticRenderFns } from "./allProcedureAnnex.vue?vue&type=template&id=58ba2ce0&scoped=true"
import script from "./allProcedureAnnex.vue?vue&type=script&lang=js"
export * from "./allProcedureAnnex.vue?vue&type=script&lang=js"
import style0 from "./allProcedureAnnex.vue?vue&type=style&index=0&id=58ba2ce0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ba2ce0",
  null
  
)

export default component.exports